import { useSession } from '../context/SessionContext';
import { Modal, Button } from 'antd';

function NetworkErrorPrompt() {
  const { networkError, setNetworkError } = useSession();

  const handleClose = () => {
    setNetworkError(false);
  };

  const handleRetry = () => {
    setNetworkError(false);
    window.location.reload();
  };

  return (
    <Modal
      open={networkError}
      footer={null}
      closable={true}
      centered
      maskClosable={true}
      keyboard={true}
      onCancel={handleClose} //
      className="network-error-modal"
    >
      <div className="text-center p-4">
        <h2 className="text-xl font-semibold mb-2">Network Error</h2>
        <p className="mb-4 text-gray-600">
          The authentication server is unreachable. Please check your connection and try again.
        </p>
        <Button
          className="bg-primary text-white hover:text-white w-full h-12 p-0 my-6 text-sm font-medium"
          onClick={handleRetry}
        >
          Retry
        </Button>
        <Button className="w-full h-12 p-0 text-sm font-medium" onClick={handleClose}>
          Close
        </Button>
      </div>
    </Modal>
  );
}

export default NetworkErrorPrompt;
